import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { templatesSelector } from "../../redux/templateSlice";

const TemplateHome = () => {
  const templates = useSelector(templatesSelector);
  return (
    templates.data &&
    templates.data.map((item, index) => (
      <Link
        to={`/templates/${item.id}`}
        className="media-template"
        key={item.id}
      >
        {item.name}
      </Link>
    ))
  );
};

export default TemplateHome;
